import { createSelector } from 'reselect';

const selectEdgeGateways = (state: any) => state.edgeGateways;


export const selectEdgeGatewaysCurrentItem = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.current);

export const selectEdgeGatewaysListItems = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectEdgeGatewaysListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEdgeGatewaysQueryItems = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.query);

export const selectEdgeGatewaysCreatedItem = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.create);

export const selectEdgeGatewaysUpdatedItem = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.update);

export const selectEdgeGatewaysReadItem = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.read);

export const selectEdgeGatewaysDeletedItem = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.delete);

export const selectEdgeGatewaysSearchedItems = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.search);

export const selectEdgeGatewaysItemsCount = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.count);

export const selectEdgeGatewaysItemsFilter = createSelector([selectEdgeGateways], (edgeGateways) => edgeGateways.filter);